/**

@module

## Anatomy

```jsx
import {
  PopoverPopup,
  PopoverPositioner,
  PopoverRoot,
  PopoverTrigger,
} from 'prosekit/react/popover'

<PopoverRoot>
  <PopoverTrigger>...</PopoverTrigger>
  <PopoverPositioner>
    <PopoverPopup>...</PopoverPopup>
  </PopoverPositioner>
</PopoverRoot>
```
*/

'use client'

export * from './index.gen.ts'
